// src/api/my_skills_api.js
import { API_BASE } from "./common_api";


/* Convert reflection → plain text */
export const convertReflectionToText = (rec) => {
  try {
    const out = [];

    if (rec?.Answers) {
      Object.values(rec.Answers).forEach((q) => {
        if (Array.isArray(q.answers)) out.push(...q.answers.filter(Boolean));
        if (typeof q.answer === "string") out.push(q.answer);
      });
    }

    if (Array.isArray(rec.Tasks)) {
      rec.Tasks.forEach((t) => {
        if (t.Task) out.push(t.Task);
        if (t.TaskDescription) out.push(t.TaskDescription);
      });
    }

    if (rec.Notes) out.push(rec.Notes);
    if (rec.Summary) out.push(rec.Summary);

    return out.join(" | ").trim();
  } catch {
    return "";
  }
};

/* Get Reflection Texts */
export const fetchReflectionTexts = async (email, periodToFetch) => {
  const periods =
    periodToFetch && periodToFetch !== "all"
      ? [periodToFetch]
      : ["daily", "weekly", "monthly"];

  const texts = [];

  for (const p of periods) {
    const res = await fetch(
      `${API_BASE}/reflection/view?email=${encodeURIComponent(
        email
      )}&period=${p}`
    );

    if (!res.ok) continue;

    const data = await res.json();
    const records = data?.records || [];

    records.forEach((rec) => {
      const txt = convertReflectionToText(rec);
      if (txt) texts.push(txt);
    });
  }

  return texts;
};

/* Skill Analysis */
export const callSkillAnalysis = async (texts) => {
  const res = await fetch(`${API_BASE}/ml/skill_analysis`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reflections: texts }),
  });

  if (!res.ok) {
    const msg = await res.text().catch(() => "");
    throw new Error(`Skill analysis failed: ${msg}`);
  }

  return await res.json();
};

/* Period Based Skills */
export const fetchPeriodSkillAnalysis = async (email, period, date) => {
  const params = new URLSearchParams({
    email,
    period,
    date_value: date,
  });

  const res = await fetch(`${API_BASE}/ml/skill_analysis_period?${params}`);

  if (!res.ok) {
    const msg = await res.text().catch(() => "");
    throw new Error(msg || "Analysis failed");
  }

  return await res.json();
};

/* Today Skill */
export const fetchTodaySkill = async (email) => {
  const today = new Date().toISOString().split("T")[0];

  const res = await fetch(
    `${API_BASE}/reflection/view?email=${encodeURIComponent(
      email
    )}&period=daily&date_value=${today}`
  );

  if (!res.ok) return [];

  const data = await res.json();
  const records = data?.records || [];

  if (!records.length) return [];

  return records[records.length - 1];
};
